import { RootState } from 'data/root.reducers';
import { CspConfig } from './cspConfig.types';

export const getCspConfigList = (state: RootState): CspConfig[] =>
  state.cspConfig.entities;
export const getCspConfig = (state: RootState): CspConfig | null =>
  state.cspConfig.single;
export const getSelectedCspConfig = (state: RootState): CspConfig[] =>
  state.cspConfig.selected;
export const getCspConfigCreatedId = (state: RootState): string | null =>
  state.cspConfig.createdId;

export const isCspConfigCreatePopupOpen = (state: RootState): boolean =>
  state.cspConfig.ui.isCreatePopupOpen;
export const isCspConfigEditPopupOpen = (state: RootState): boolean =>
  state.cspConfig.ui.isEditPopupOpen;
export const isCspConfigLoading = (state: RootState): boolean =>
  state.cspConfig.ui.isLoading;
